import { Component } from '@angular/core';

@Component({
  selector: 'tgrid-page-footer',
  standalone: true,
  imports: [],
  template: `
    <div class="notes-section">
      <ul>
        <li>Due to the potentially sensitive information contained within TASTI-GRID, DOE must approve all user
          accounts.
        </li>
        <li>TASTI-GRID is developed by Oak Ridge National Laboratory with support from the U.S. Department of Energy’s
          Grid Deployment Office. TASTI-GRID stands for “Technical Assistance for States and Tribes Initiative: Grid
          Resilience Investment Decision-Making.”
        </li>
      </ul>
    </div>
  `,
  styles: `
    .notes-section {
      ul {
        padding-left: 15px;
      }
    }
  `,
})
export class PageFooterComponent {

}
